import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** cn — combina classes Tailwind, deduplicando conflitos. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Mascara email para logs (LGPD). */
export function maskEmail(email: string): string {
  const [name = '', domain = ''] = email.split('@');
  if (!name || !domain) return '***';
  return `${name.slice(0, 1)}***@${domain.split('.')[0]?.[0] ?? '*'}***.${domain.split('.').pop() ?? ''}`;
}

export function sleep(ms: number): Promise<void> {
  return new Promise((res) => setTimeout(res, ms));
}
